var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBlockJob = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 150,
    viewBox: "0 0 200 150",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.989 135.901C136.005 135.901 162.772 109.135 162.772 76.0009C162.772 42.8671 135.887 16.1006 102.989 16.1006C69.9735 16.1006 43.207 42.8671 43.207 76.0009C43.207 109.135 69.9735 135.901 102.989 135.901Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.881 36.7373C161.551 36.7373 163.716 34.5728 163.716 31.9028C163.716 29.2328 161.551 27.0684 158.881 27.0684C156.211 27.0684 154.047 29.2328 154.047 31.9028C154.047 34.5728 156.211 36.7373 158.881 36.7373Z",
    fill: "#F8F8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.954 17.8708C167.777 17.8708 169.256 16.3926 169.256 14.5692C169.256 12.7458 167.777 11.2676 165.954 11.2676C164.131 11.2676 162.652 12.7458 162.652 14.5692C162.652 16.3926 164.131 17.8708 165.954 17.8708Z",
    fill: "#F8F8F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3875 36.6188C48.2109 36.6188 49.6891 35.1406 49.6891 33.3172C49.6891 31.4938 48.2109 30.0156 46.3875 30.0156C44.5641 30.0156 43.0859 31.4938 43.0859 33.3172C43.0859 35.1406 44.5641 36.6188 46.3875 36.6188Z",
    fill: "#F8F8F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2253 100.291C29.6116 100.291 32.3568 97.5462 32.3568 94.1599C32.3568 90.7735 29.6116 88.0283 26.2253 88.0283C22.8389 88.0283 20.0938 90.7735 20.0938 94.1599C20.0938 97.5462 22.8389 100.291 26.2253 100.291Z",
    fill: "#F8F8F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27021_145261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.669 46.0517L144.612 121.988C144.612 124.582 142.49 126.587 139.895 126.587H65.8455C63.2514 126.587 61.1289 124.464 61.1289 121.988V24.3555C61.1289 21.7614 63.2514 19.7568 65.8455 19.7568H119.496L143.669 46.0517Z",
    fill: "#F8F8F8"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2092 111.376H82.7058C82.1162 111.376 81.6445 110.787 81.6445 110.079C81.6445 109.372 82.1162 108.782 82.7058 108.782H97.2092C97.7988 108.782 98.2704 109.372 98.2704 110.079C98.2704 110.905 97.7988 111.376 97.2092 111.376Z",
    fill: "#E6E6E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9555 111.376H73.155C72.5654 111.376 72.0938 110.787 72.0938 110.079C72.0938 109.372 72.5654 108.782 73.155 108.782H88.9555C89.545 108.782 90.0167 109.372 90.0167 110.079C90.0167 110.905 89.545 111.376 88.9555 111.376Z",
    fill: "#E6E6E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.119 35.6761H73.6266C72.8012 35.6761 72.0938 34.9686 72.0938 34.1432C72.0938 33.3178 72.8012 32.6104 73.6266 32.6104H109.119C109.944 32.6104 110.652 33.3178 110.652 34.1432C110.652 34.9686 109.944 35.6761 109.119 35.6761Z",
    fill: "#E6E6E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3047 44.1664H73.6266C72.8012 44.1664 72.0938 43.4589 72.0938 42.6335C72.0938 41.8081 72.8012 41.1006 73.6266 41.1006H87.1867C88.0121 41.1006 88.7196 41.8081 88.7196 42.6335C88.7196 43.4589 88.0121 44.1664 87.3047 44.1664Z",
    fill: "#E6E6E6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119.496 19.7568V40.7455C119.496 43.6934 122.09 46.0517 125.038 46.0517H143.668",
    fill: "#E6E6E6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M133.13 90.9717H92.2187H87.7096H74.0724C73.5225 90.9717 72.9727 91.5227 72.9727 92.2942C72.9727 92.9555 73.4126 93.6167 74.0724 93.6167H87.7096H92.2187H133.13C133.68 93.6167 134.23 93.0657 134.23 92.2942C134.12 91.5227 133.68 90.9717 133.13 90.9717Z",
    fill: "#E6E6E6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M133.02 81.3818H117.843H112.675H74.0724C73.5225 81.3818 72.9727 81.9329 72.9727 82.7044C72.9727 83.3656 73.4126 84.0269 74.0724 84.0269H112.675H117.843H133.02C133.57 84.0269 134.12 83.4759 134.12 82.7044C134.01 81.9329 133.57 81.3818 133.02 81.3818Z",
    fill: "#E6E6E6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.35 71.6855H129.391H125.432H74.0724C73.5225 71.6855 72.9727 72.2366 72.9727 73.0081C72.9727 73.6693 73.4126 74.3306 74.0724 74.3306H125.432H129.831H133.24C133.79 74.3306 134.34 73.7796 134.34 73.0081C134.45 72.3468 133.9 71.6855 133.35 71.6855Z",
    fill: "#E6E6E6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2391 112.352H74.0724C73.5225 112.352 72.9727 111.801 72.9727 111.03C72.9727 110.368 73.4126 109.707 74.0724 109.707H90.2391C90.789 109.707 91.3389 110.258 91.3389 111.03C91.3389 111.911 90.789 112.352 90.2391 112.352Z",
    fill: "#F8F8F8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M133.79 62.0977H120.923H117.733H74.0724C73.5225 62.0977 72.9727 62.6487 72.9727 63.4202C72.9727 64.0815 73.4126 64.7427 74.0724 64.7427H117.733H120.923H133.68C134.45 64.7427 134.89 64.1917 134.89 63.4202C134.89 62.7589 134.45 62.0977 133.79 62.0977Z",
    fill: "#E6E6E6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9479 118.195H48.9932C46.1337 118.195 43.8242 115.881 43.8242 113.015V76.976C43.8242 66.9468 51.9626 58.9014 61.8605 58.9014C71.7585 58.9014 79.8968 67.057 79.8968 76.976V113.125C80.0068 115.881 77.6973 118.195 74.9479 118.195ZM54.1621 107.945H69.7789V76.976C69.7789 72.6778 66.2596 69.151 61.9705 69.151C57.6814 69.151 54.1621 72.6778 54.1621 76.976V107.945Z",
    fill: "#C4C4C4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6173 128.003H38.6569C35.4676 128.003 32.8281 125.358 32.8281 122.162V90.9721C32.8281 87.7759 35.4676 85.1309 38.6569 85.1309H85.6173C88.8067 85.1309 91.4461 87.7759 91.4461 90.9721V122.162C91.4461 125.358 88.8067 128.003 85.6173 128.003Z",
    fill: "#E6E6E6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0221 101.772C68.0221 104.086 66.7024 106.07 64.8328 107.062V113.454C64.8328 114.997 63.623 116.209 62.0833 116.209C60.5436 116.209 59.3339 114.997 59.3339 113.454V107.062C57.4643 106.07 56.1445 104.086 56.1445 101.772C56.1445 98.4654 58.784 95.8203 62.0833 95.8203C65.3826 95.8203 68.0221 98.4654 68.0221 101.772Z",
    fill: "#C4C4C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27021_145261",
    x: 45.1289,
    y: 7.75684,
    width: 115.484,
    height: 138.83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27021_145261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27021_145261",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBlockJob, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/block-job.59e530ed.svg";
export { ForwardRef as ReactComponent };